var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "#466AEF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26 15.25C20.0629 15.25 15.25 20.0629 15.25 26C15.25 31.9371 20.0629 36.75 26 36.75C31.9371 36.75 36.75 31.9371 36.75 26C36.75 20.0629 31.9371 15.25 26 15.25ZM25.9916 20.25C24.1958 20.25 22.7381 21.7041 22.7381 23.5C22.7381 25.2959 24.1958 26.75 25.9916 26.75C27.7875 26.75 29.2452 25.2959 29.2452 23.5C29.2452 21.7041 27.7875 20.25 25.9916 20.25ZM31.0409 30.4802C28.3735 27.6002 23.5747 27.7487 20.9638 30.4756L20.7763 30.6631C20.631 30.8084 20.5517 31.0069 20.5569 31.2123C20.562 31.4177 20.6512 31.612 20.8036 31.7498C22.1777 32.9923 24.0013 33.75 26.0001 33.75C27.9989 33.75 29.8225 32.9923 31.1966 31.7498C31.349 31.612 31.4382 31.4177 31.4433 31.2123C31.4485 31.0069 31.3692 30.8084 31.2239 30.6631L31.0409 30.4802Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/Support.17c98b29f1b7984f824d9ba2883e78fb.svg";
export { ForwardRef as ReactComponent };